/**
 * DeliveryIcons — EKSELENS360 service-line, ENTERPRISE360 value-stream and
 * lifecycle phase-spine iconography. Now backed by the OFFICIAL Ekselens design
 * system v1.2 artwork (vendored SVGs in assets/ekicons, wired via EkIcon).
 * Stroke-only `currentColor` — colour is inherited (lilac on dark, purple on
 * light), so this never affects the palette or the light/dark theme.
 */
import React from "react";
import { EkIcon } from "./EkIcon";

// service-line code (e.g. "AI360") → vendored icon slug ("ai360")
const svg = (name, className) => <EkIcon name={name} className={className} />;

export const SERVICE_LINE_ICONS = Object.fromEntries(
  ["AI360", "BENEFITS360", "CAPABILITY360", "CHANGE360", "DATA360", "DIGITAL360",
   "GOVERN360", "ITSM360", "OPERATING360", "PMO360", "STAKEHOLDER360", "SUPPLIER360"]
    .map((code) => [code, ({ className }) => svg(code.toLowerCase(), className)])
);

export const VALUE_STREAM_ICONS = Object.fromEntries(
  ["captive-finance", "enabling-data", "enabling-it", "hire-to-retire", "idea-to-market",
   "lead-to-order", "order-to-cash", "plan-to-produce", "record-to-report",
   "risk-to-assurance", "source-to-pay", "strategy-to-execution"]
    .map((id) => [id, ({ className }) => svg(id, className)])
);

// Lifecycle phase spine (Discover → Optimise)
export const PHASE_ICONS = Object.fromEntries(
  ["discover", "diagnose", "design", "plan", "mobilise", "deliver", "embed", "optimise"]
    .map((p) => [p, ({ className }) => svg(p, className)])
);

export const ServiceLineIcon = ({ code, className = "w-5 h-5" }) => {
  const Icon = SERVICE_LINE_ICONS[code];
  return Icon ? <Icon className={className} /> : null;
};

export const ValueStreamIcon = ({ id, className = "w-5 h-5" }) => {
  const Icon = VALUE_STREAM_ICONS[id];
  return Icon ? <Icon className={className} /> : null;
};

export const PhaseIcon = ({ phase, className = "w-5 h-5" }) => {
  const Icon = PHASE_ICONS[phase];
  return Icon ? <Icon className={className} /> : null;
};
